import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import { ApplicationState } from 'reducers/';
import { connect } from 'react-redux';
import { bannerListAll, updateBannerVariables, BannerUrlTarget } from '@api/graphql/types';
import * as Queries from '@api/graphql/queries';
import BannerForm from '../components/BannerForm';


type Props = {
    bannerId?: number,
} & InjectedIntlProps & RouteComponentProps<{bannerId: string}>;

interface State {
    formData: updateBannerVariables;
}

class BannerEdit extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            formData: {
                id: '',
                name: '',
                active_from: null,
                active_to: null,
                url: '',
                url_target: BannerUrlTarget._self,
                image_url_desktop: '',
                image_url_mobile: '',
                is_active: true,
                priority: 0,
                banner_place_ids: [],
            },
        };
    }

    public componentDidMount() {
        const variables = {filters: {id: this.props.bannerId}, count: 1};
        GraphQLClient.query<bannerListAll>({
            query: Queries.bannerListAll,
            variables,
        }).then((response) => {
            if (response.data && response.data.adminBanners && response.data.adminBanners.data && response.data.adminBanners.data[0]) {
                const { id, name, active_from, active_to, url, url_target, image_url_desktop, image_url_mobile, is_active, priority } = response.data.adminBanners.data[0];
                const bannerPlaceIds = response.data.adminBanners.data[0].banner_places.map((bannerPlace) => bannerPlace.id);
                this.setState({formData: { id, name, active_from, active_to, url, url_target, image_url_desktop, image_url_mobile, is_active, priority, banner_place_ids: bannerPlaceIds }});
            }
        });
    }

    public onSubmit = (variables: updateBannerVariables) => {
        return GraphQLClient.mutate({
            mutation: Mutations.updateBanner, variables,
        });
    }

    public render() {
        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>{this.props.intl.formatMessage({id: 'module.banner.edit.title'})}</h5>
                        </div>
                        <div className="ibox-content">
                            <BannerForm
                                formData={this.state.formData}
                                onSubmit={this.onSubmit}
                                redirectFunction={() => undefined}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ApplicationState, props: Props) => {
    const { bannerId } = props.match.params;
    return { bannerId: parseInt(bannerId, 10) };
};

export default compose(
    injectIntl,
    withRouter,
    connect(mapStateToProps),
)(BannerEdit);



// WEBPACK FOOTER //
// ./src/modules/Banner/pages/BannerEdit.tsx